/** Use UTM params, in particular on a page without forms */
export const useUtmParams = () => {
  const utmParams: Ref<Record<string, string>> = ref({});

  // listen for form injection events to capture UTM params
  useHekateEventBus().addEventListener('form-inject-value', (event) => {
    const { data } = event;
    const { fieldName, fieldValue } = data as { fieldName: string; fieldValue: string };
    if (!fieldName.startsWith('utm_')) {
      return;
    }
    utmParams.value = {
      ...utmParams.value,
      [fieldName]: fieldValue,
    };
  });

  // setup form injections to listen for UTM params
  useFormInjections({
    formId: null,
  });

  // dispatch event after a delay to allow other components to initialize
  setTimeout(() => {
    useHekateEventBus().dispatchEvent('request-form-injections', {});
  }, 3000);

  return {
    utmParams,
  };
};
